import { render, staticRenderFns } from "./ChangePasswordMail.vue?vue&type=template&id=523e24a6&"
import script from "./ChangePasswordMail.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports